import PropTypes from "prop-types";
import { useCookies } from "react-cookie";

import { Box, Button, FormLabel, TextareaAutosize } from "@material-ui/core";

import { checkRoles } from "../../../utils/Roles";
import { useStyles } from "../../../Styles/styles";

const NarrativeSegmentInput = ({
  blocked,
  roles,
  isOnIncident,
  userId,
  onChange,
  value,
  disabled,
  onSave,
  onCancel,
  createdIncident,
}) => {
  const [cookies] = useCookies();
  const classes = useStyles();

  const hasRole = checkRoles(roles, "add_dispatch_narratives");

  const showNarrativeInput =
    (hasRole || isOnIncident || createdIncident) && !blocked;

  if (showNarrativeInput) {
    return (
      <>
        <FormLabel
          component="label"
          data-testid="narrative-segment-input-label"
          htmlFor="newNarrative-id"
        >
          {"New\xa0Dispatch\xa0Narrative"}
        </FormLabel>
        <TextareaAutosize
          data-testid="narrative-segment-input-textarea"
          onChange={onChange}
          className={
            cookies[`mp-userId-${userId}-night-mode`] === "true"
              ? classes.textAreaDark
              : classes.textAreaLight
          }
          style={{ borderRadius: "5px" }}
          margin="dense"
          id="newNarrative-id"
          value={value}
          minRows={2}
          name="newNarrative"
          disabled={disabled}
        />
        <Box display="flex" flexDirection="row">
          <Button
            data-testid="narrative-segment-input-submit-button"
            disabled={disabled}
            style={{
              width: "fit-content",
              marginTop: "1vh",
              marginBottom: "3vh",
              marginRight: "2vw",
            }}
            variant="contained"
            onClick={onSave}
          >
            Submit
          </Button>
          <Button
            data-testid="narrative-segment-input-cancel-button"
            disabled={disabled}
            style={{
              width: "fit-content",
              marginTop: "1vh",
              marginBottom: "3vh",
            }}
            variant="contained"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </Box>
      </>
    );
  } else {
    return null;
  }
};

NarrativeSegmentInput.propTypes = {
  blocked: PropTypes.bool,
  roles: PropTypes.arrayOf(PropTypes.string),
  isOnIncident: PropTypes.bool,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  createdIncident: PropTypes.bool,
};

export default NarrativeSegmentInput;
